import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import IconButton from '../../../../../Buttons/IconButton';
const LargeInputIconButton = (props)=>{
    return /*#__PURE__*/ React.createElement(IconButton, _object_spread({
        variant: "main",
        type: "button"
    }, props));
};
LargeInputIconButton.displayName = 'LargeInputIconButton';
export default LargeInputIconButton;

//# sourceMappingURL=LargeInputIconButton.js.map